import React, { useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Button } from 'react-bootstrap';
import { useTranslation } from "react-i18next";


export default function FinishScanSave({show, setShow}) {
    
    const { t, i18n } = useTranslation();
    // const [show, SetShow] = useState(false);
    const fClose = ()=>{
        setShow(false);
        console.log("CLOSE MODAL");
    };
  return (
    <Modal show={show} size='sm'>
        <ModalHeader style={{fontSize: "20px", padding: "5px 15px"}}>
            <ModalTitle style={{fontSize: "20px"}}>{t("info")}</ModalTitle>
        </ModalHeader>
        <ModalBody>{t("modal-body")}</ModalBody>
        <ModalFooter><Button onClick={fClose} size='sm'>{t("close-modal")}</Button></ModalFooter>
    </Modal>
  )
}
